import { render, staticRenderFns } from "./standalone.vue?vue&type=template&id=7bb3afe5&"
import script from "./standalone.vue?vue&type=script&lang=js&"
export * from "./standalone.vue?vue&type=script&lang=js&"
import style0 from "./standalone.vue?vue&type=style&index=0&id=7bb3afe5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports